<template>
  <div>
    <div class="container-fluid bg-dark-gold">
      <div class="row py-2 d-flex justify-content-between">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <h3 class="mb-0 text-white">
                {{ business.name }}
              </h3>
            </div>
            <colour-tag
              class="mx-1"
              :obj="business.open_trades ? activeTags[1] : activeTags[0]"
            />
          </div>
        </div>
      </div>
      <div class="row d-lg-none text-center pt-2 pb-4">
        <div class="col-4 font-weight-bold text-casper">Open Trades</div>
        <div class="col-4 font-weight-bold text-casper">
          Total HD with Ottley
        </div>
        <div class="col-4 font-weight-bold text-casper">
          Ottley Balance Today
        </div>
        <div class="col-4 font-weight-bold text-white">
          {{ summaryData.open_trades }}
        </div>
        <div class="col-4 font-weight-bold text-white">
          {{ summaryData.livestock_head_on_hand }}
        </div>
        <div class="col-4 font-weight-bold text-white">
          ${{ $_toLocaleString(summaryData.balance_today) }}
          <el-tooltip content="Livestock + Mgmt Fee (inc) as at Today" placement="top">
            <i class="fas fa-info-circle"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="container-fluid py-0">
      <div class="d-none d-lg-block">
        <div class="row">
          <div class="col-lg-6 col-sm-12">
            <el-card style="height: 100%" shadow="always" class="bg-light-grey">
              <div class="row">
                <div class="col-3 font-weight-bold text-casper">
                  Trading Name
                </div>
                <div class="col-3 font-weight-bold text-casper">
                  Nickname

                  <business-nickname-form
                    v-if="!isProducer"
                    :initial_business="business"
                    @refresh="refreshShortName"
                  ></business-nickname-form>
                </div>
                <div class="col-3 font-weight-bold text-casper">ABN</div>
                <div class="col-3 font-weight-bold text-casper">
                  Physical Address
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{ business.name }}
                </div>
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{ business.short_name }}
                </div>
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{ maskABN(business.abn) }}
                </div>
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{ business.address ? business.address : "--" }}
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3 font-weight-bold text-casper">
                  Business Type
                </div>
                <div class="col-3 font-weight-bold text-casper">Email</div>
                <div class="col-3 font-weight-bold text-casper">Phone</div>

                <div
                  class="col-3 font-weight-bold text-casper"
                  v-if="!isProducer"
                >
                  MLSSA
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{
                    business.business_type ? business.business_type.name : "--"
                  }}
                </div>
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{ business.email ? business.email : "--" }}
                </div>
                <div class="col-3 text-dark-blue font-weight-bold">
                  {{ business.phone ? business.phone : "--" }}
                </div>
                <div
                  class="col-3 text-dark-blue font-weight-bold"
                  v-if="!isProducer"
                >
                  <i class="fa fa-file fa-lg"></i>
                </div>
              </div>
            </el-card>
          </div>
          <div class="col-lg-6 col-sm-12">
            <el-card style="height: 100%" shadow="always" class="bg-light-grey">
              <div role="warning" class="alert alert-warning py-2 text-navy mb-3" style="margin: -20px -20px 0 -20px;">
                Values update daily. Upcoming or pending payments will not be included below.
              </div>
              <div class="row mt-4">
                <div
                  class="col-4 font-weight-bold text-casper fa-sm text-center"
                >
                  Total HD with Ottley
                </div>
                <div
                  class="col-4 font-weight-bold text-casper fa-sm text-center"
                >
                  Open Trades
                </div>
                <div
                  class="col-4 font-weight-bold text-casper fa-sm text-center"
                >
                  Ottley Balance Today
                </div>
              </div>
              <div class="row mt-2">
                <div
                  class="col-4 text-dark-blue font-weight-bold h5 text-center"
                >
                  {{ summaryData.livestock_head_on_hand }}
                </div>
                <div
                  class="col-4 text-dark-blue font-weight-bold h5 text-center"
                >
                  {{ summaryData.open_trades }}
                </div>
                <div
                  class="col-4 text-dark-blue font-weight-bold h5 text-center"
                >
                  ${{ $_toLocaleString(summaryData.balance_today) }}
                  <el-tooltip content="Livestock + Mgmt Fee (inc) as at Today" placement="top">
                    <i class="fas fa-info-circle"></i>
                  </el-tooltip>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>

      <div class="row my-4" v-if="business.onboarding_step < 4 && false">
        <div class="col-12 text-right mb-3">
          <a
            :href="`/businesses/${business.id}/edit`"
            class="action-btn text-uppercase"
            type="primary"
          >
            Continue account setup
          </a>
        </div>
        <div class="col-12">
          <div class="row d-flex justify-content-between align-items-center">
            <el-tag
              v-for="(tag, index) in tags"
              class="col-2 text-cello font-weight-bold shadow-tag"
              :key="index"
              :type="getType(index)"
              >{{ tag }}</el-tag
            >
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div
          class="col-lg-6 col-sm-12"
          :class="[
            { 'd-sm-block d-block': selectedOption == 4 },
            'd-none d-lg-block',
          ]"
        >
          <business-properties
            :initial_business="business"
            :regions="regions"
          ></business-properties>
        </div>
        <div
          class="col-lg-6 col-sm-12"
          :class="[
            { 'd-sm-block d-block': selectedOption == 5 },
            'd-none d-lg-block',
          ]"
        >
          <business-guarantors
            :initial_business="business"
            :is-producer="isProducer"
          />
        </div>
      </div>

      <div
        class="row mt-2"
        :class="[
          'd-none d-lg-block',
          { 'd-sm-block d-block': [1, 2, 3].includes(selectedOption) },
        ]"
      >
        <div class="col-lg-12">
          <business-trades
            :key="keyTrades"
            :initial_business="business"
            :is-producer="isProducer"
            :selected-option="selectedOption"
          />
        </div>
      </div>
      <div class="row mt-2">
        <div
          class="col-lg-6 col-sm-12"
          :class="[
            { 'd-sm-block d-block': selectedOption == 6 },
            'd-none d-lg-block',
          ]"
        >
          <business-statement
            :initial_business="business"
            :is-producer="isProducer"
            :selected-option="selectedOption"
          ></business-statement>
        </div>
        <div
          class="col-lg-6 col-sm-12"
          :class="[
            { 'd-sm-block d-block': selectedOption == 7 },
            'd-none d-lg-block',
          ]"
        >
          <business-order-confirmation
            :initial_business="business"
            :is-producer="isProducer"
            :selected-option="selectedOption"
          ></business-order-confirmation>
        </div>
      </div>

      <!-- logs -->
      <div class="row mt-2" v-if="!isProducer">
        <div class="col-12">
          <business-logs
            class="d-none d-lg-block"
            :initial_business="business"
          ></business-logs>
        </div>
      </div>

      <div class="row d-lg-none" v-for="option in pageOptions" :key="option.id">
        <div
          class="col-12 bg-slate-grey rounded p-4 shadow-sm m-2 d-flex justify-content-between align-items-center has-interaction"
          @click="selectOption(option)"
          v-if="selectedOption != option.id"
        >
          <h1 class="text-dark-blue">{{ option.name }}</h1>
          <i
            class="el-icon font-weight-bold font-22 px-3 el-icon-arrow-right"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ABNFormat from "../../../mixins/ABNFormat";
import OttleyFormatter from "../../../mixins/OttleyFormatter";
import BusinessStatuses from "../../../constants/BusinessStatuses.js";
import ColourTag from "../../../common/ColourTag.vue";
import Business from "../../modelsPortal/Business";
import BusinessNicknameForm from "./components/BusinessNicknameForm.vue";
import BusinessStatement from "./show/BusinessStatement.vue";
import BusinessOrderConfirmation from "./show/BusinessOrderConfirmation.vue";

export default {
  components: {
    ColourTag,
    BusinessNicknameForm,
    BusinessStatement,
    BusinessOrderConfirmation,
  },
  mixins: [ABNFormat, OttleyFormatter],
  props: {
    initial_business: {
      type: Object,
    },
    regions: {
      type: Array,
    },
    isProducer: {
      type: Number,
    },
  },
  computed: {
    business_status() {
      let statuses = Object.keys(BusinessStatuses).map((key) => {
        return BusinessStatuses[key];
      });

      return statuses.filter(
        (x) => x.id == this.initial_business.business_status_id,
      )[0];
    },
  },
  data() {
    return {
      selectedOption: null,
      keyTrades: 0,
      pageOptions: [
        { name: "Open Trades", id: 1 },
        { name: "Past Trades", id: 2 },
        { name: "Pending Trades", id: 3 },
        { name: "Property Details", id: 4 },
        { name: "Contacts", id: 5 },
        { name: "Statements", id: 6 },
        { name: "Order Confirmations", id: 7 },
      ],
      activeTags: [
        { name: "Inactive", colour: "#c93636", bg_colour: "#fef0f0" },
        { name: "Active", colour: "#41af1a", bg_colour: "#ecf7e8" }
      ],
      tags: [
        "ABN Check & Business Info Details",
        "Contact Information",
        "PIC Details",
        "AML Additional Documents",
        "COMPLETE",
      ],
      active_tag: this.initial_business
        ? this.initial_business.onboarding_step
        : 0,
      business: this.initial_business,
      summaryData: {
        livestock_head_on_hand: 0,
        average_head_price: 0,
        open_trades: 0,
        balance_today: 0,
      },
    };
  },
  mounted() {
    this.getTradeSummary();
  },
  methods: {
    refreshShortName(value) {
      this.business.short_name = value;
    },
    selectOption(option) {
      this.selectedOption = option.id;
      if ([1, 2, 3].includes(option.id)) this.keyTrades++;
    },
    getTradeSummary: function () {
      this.tableLoading = true;
      axios
        .get(`/api/v2/portal/businesses/${this.business.id}/trade-summary`)
        .then((res) => {
          this.summaryData = res.data;
          this.business.open_trades = this.summaryData.open_trades > 0;
        });
    },
    getStatusType: function (status, type = null) {
      if (
        ["Pending Data", "More Info Required", "Pending Approval"].includes(
          status,
        )
      ) {
        return "warning";
      } else if (["Draft"].includes(status)) {
        return "info";
      } else if (["Approved"].includes(status)) {
        return "success";
      } else if (["Declined", "Frozen"].includes(status)) {
        return "danger";
      } else {
        return "info";
      }
    },
    getType(index) {
      if (this.active_tag > index) return "success";
      else if (index >= this.active_tag) return "info";
    },
  },
};
</script>
<style scoped>
.shadow-tag {
  box-shadow: 0 0.2rem 5px rgb(0 0 0 / 15%) !important;
}
</style>
